import { TimeVector24 } from './TimeVector24';
export var formatDateTimeVector = function formatDateTimeVector(dateVector) {
  var enableTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!dateVector) {
    return '';
  }

  var year = dateVector.formattedYear;
  var month = dateVector.formattedMonth;
  var day = dateVector.formattedDay;

  if (enableTime) {
    var timeVector = TimeVector24.createFromDateVector(dateVector).convertTo12();
    var formattedHour = timeVector.formattedHour,
        formattedMinute = timeVector.formattedMinute,
        mode = timeVector.mode;
    return "".concat(formattedHour, ":").concat(formattedMinute, " ").concat(mode, " ").concat(day, "/").concat(month, "/").concat(year);
  }

  return "".concat(day, "/").concat(month, "/").concat(year);
};